export default __webpack_public_path__ + "static/media/new_form_svg.d1c2758e.svg";